import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base:process.env.NODE_ENV === 'development' ? '/gzh-test' : '/',
  base:'/front/tailg-gzh-vue',
  routes: [
    {
      path: '/',
      name: 'myGarage',
      component: (resolve) => require(['../pages/myGarage'], resolve),
      meta: {
        title: '我的车库'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: (resolve) => require(['../pages/login'], resolve)
    },
    {
      path: '/productInfo',
      name: 'productInfo',
      component: (resolve) => require(['../pages/productInfo'], resolve),
      meta: {
        title: '车辆信息'
      }
    },
    {
      path: '/informationEntry',
      name: 'informationEntry',
      component: (resolve) => require(['../pages/informationEntry'], resolve),
      meta: {
        title: '车主录入信息'
      }
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: (resolve) => require(['../pages/pdf'], resolve),
      meta: {
        title: '第二代保险告知书'
      }
    },
    {
      path: '/questionCenter',
      name: 'questionCenter',
      component: (resolve) => require(['../pages/questionCenter'], resolve),
      meta: {
        title: '在线理赔'
      }
    },
    {
      path: '/information',
      name: 'information',
      component: (resolve) => require(['../pages/information'], resolve),
      meta: {
        title: '资讯'
      }
    },
    {
      path: '/product',
      name: 'product',
      component: (resolve) => require(['../pages/product'], resolve),
      meta: {
        title: '产品'
      }
    },
    {
      path: '/banner',
      name: 'banner',
      component: (resolve) => require(['../pages/banner'], resolve),
      meta: {
        title: 'banner'
      }
    },
    {
      path: '/insurance',
      name: 'store',
      component: (resolve) => require(['../pages/store'], resolve),
      meta: {
        title: '门店'
      }
    },
    {
      path: '/store',
      name: 'insurance',
      component: (resolve) => require(['../pages/insurance'], resolve),
      meta: {
        title: '经销商门店投保'
      }
    },
    {
      path: '/sanbao',
      name: 'saobao',
      component: (resolve) => require(['../pages/sanbao'], resolve),
      meta: {
        title: '三包信息查询'
      }
    },
    {
      path: '/sanbao/detail',
      name: 'saobaoDetail',
      component: (resolve) => require(['../pages/sanbao/detail'], resolve),
      meta: {
        title: '维修记录'
      }
    },
    {
      path: '/cityOutlets',
      name: 'cityOutlets',
      component: (resolve) => require(['../pages/cityOutlets'], resolve),
      meta: {
        title: '城市网点'
      }
    },
    {
      path: '/download',
      name: 'download',
      component: (resolve) => require(['../pages/download'], resolve),
      meta: {
        title: '下载'
      }
    },
    {
        path:'/authpage',
        name:'authpage',
        component: () => import('../pages/authPage/authPage'),
        meta: {
            title:'提交状态'
        }
    },
    {
        path:'/phonelogin',
        name:'phonelogin',
        component: () => import('../pages/phoneLogin/phoneLogin'),
        meta: {
            title:'绑定手机号'
        }
    },
    {
        path:'/ownercode',
        name:'ownercode',
        component: () => import('../pages/ownerCode/ownerCode'),
        meta: {
            title:'台铃车主码'
        }
    },
    {
        path:'/ownerinfo',
        name:'ownerinfo',
        component: () => import('../pages/ownerInfo/ownerInfo'),
        meta: {
            title:'提交信息'
        }
    },
    {
        path:'/storevisit',
        name:'storevisit',
        component: () => import('../pages/storeVisit/index'),
        meta: {
            title:'门店打卡'
        }
    },
    {
        path:'/storevisitdata',
        name:'storevisitdata',
        component: () => import('../pages/storeVisitData/index'),
        meta: {
            title:'新建',
            keepAlive:true
        }
    },
    {
        path:'/storeVisitDetail',
        name:'storeVisitDetail',
        component: () => import('../pages/storeVisitDetail/index'),
        meta: {
            title:'详情',
            keepAlive:false
        }
    },
    {
        path:'/questionnaire',
        name:'questionnaire',
        component: () => import('../pages/questionnaire/index'),
        meta: {
            title:'问卷调查',
            keepAlive:true
        }
    },
    {
        path:'/market',
        name:'market',
        component: () => import('../pages/market/index'),
        meta: {
            title:'问卷调查',
            keepAlive:true
        }
    },
    {
      path:'/feedbackCenter',
      name:'feedbackCenter',
      component: () => import('../pages/feedbackCenter/index'),
      meta: {
          title:'帮助中心',
          keepAlive:true
      }
  },
  ]
})